import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useMemo } from 'react'
import useSession from 'tennders-auth/hooks/useSession'
import useBoardView from 'tennders-market/common/hooks/useBoardView'
import GeneralLayout from 'tennders-stracture/layouts/views/GeneralLayout'
import GeneralLayoutHeader from 'tennders-stracture/layouts/views/GeneralLayoutHeader'
import GeneralLayoutUserMenu from 'tennders-stracture/layouts/views/GeneralLayoutUserMenu'
import GeneralLayoutLoading from 'tennders-stracture/layouts/views/GeneralLayoutLoading'
import GeneralLayoutOuterTop from 'tennders-stracture/layouts/views/GeneralLayoutOuterTop'
import GeneralLayoutTopMenu from 'tennders-stracture/layouts/views/GeneralLayoutTopMenu'
import GeneralLayoutSearchFilter from 'tennders-stracture/layouts/views/GeneralLayoutSearchFilter'
import GeneralLayoutRecentFilter from 'tennders-stracture/layouts/views/GeneralLayoutRecentFilter'
import GeneralLayoutSidebar from 'tennders-stracture/layouts/views/GeneralLayoutSidebar'
import GeneralLayoutContent from 'tennders-stracture/layouts/views/GeneralLayoutContent'
import { SearchTypes } from 'tennders-common/types/SearchTypes'
import GeneralLayoutSearchFilterBroker from 'tennders-stracture/layouts/views/GeneralLayoutSearchFilterBroker'
import dynamic from 'next/dynamic'
import BinBrokerBidView from 'tennders-market/bin/views/list/BinBrokerBidView'
import { useRouter } from 'next/router'

const BoardView = dynamic(() => import('tennders-market/load/views/board/LoadBoardView'))
const BinCarrierBidView = dynamic(() => import('tennders-market/bin/views/list/BinCarrierBidView'))
const BinShipperBidView = dynamic(() => import('tennders-market/bin/views/list/BinShipperBidView'))

function Home() {
  const { t } = useTranslation()
  const { isBrokerUser, isCarrierUser, isShipperUser } = useSession()
  const { listMode, setListMode, setUserMode, userMode, tag, setTag } = useBoardView()
  const { query } = useRouter()

  const searchPlaceholder = useMemo(() => (
    t('topMenu:' + (isShipperUser ? 'search_my_loads' : isCarrierUser ? 'search_my_trucks' : 'search_my_board'))
  ), [isBrokerUser, isCarrierUser, isShipperUser])

  const breadcrumb = useMemo(() => ([
    { label: t('menu:' + (isBrokerUser ? 'myBoard' : isShipperUser ? 'my_loads' : 'my_trucks')) }
  ]), [isBrokerUser, isShipperUser])

  const content = useMemo(() => (
    <>
      {isBrokerUser
        ? (listMode === 'board' ? <BoardView refreshKey="transaction" /> : <BinBrokerBidView refreshKey={SearchTypes.MY_BOARD} />)
        : isCarrierUser
          ? <BinCarrierBidView refreshKey={SearchTypes.MY_BOARD} />
          : isShipperUser && <BinShipperBidView refreshKey={SearchTypes.MY_BOARD} />}
    </>
  ), [isBrokerUser, isCarrierUser, isShipperUser, listMode])

  useEffect(() => {
    if (query?.mode && query?.mode !== listMode && isBrokerUser) {
      setListMode(query.mode)
    }
    if (query?.userMode && query?.userMode !== userMode && isBrokerUser) {
      setUserMode(query.userMode)
    }
    if (query?.tag && query?.tag !== tag && isBrokerUser) {
      setTag(query.tag.toString())
    } else if (tag && !query.tag && isBrokerUser) {
      setTag(null)
    }
  }, [query, isBrokerUser])

  return (
    <GeneralLayout>
      <GeneralLayoutHeader />
      <GeneralLayoutUserMenu />
      <GeneralLayoutOuterTop>
        <GeneralLayoutTopMenu
          breadCrumb={breadcrumb}
          withBoardView={isBrokerUser}
          filterKey={SearchTypes.MY_BOARD}
          withUserMode={isBrokerUser}
          withSearch
          searchPlaceholder={searchPlaceholder}
          withFiltersButton
          withButtonToggleGroup={isBrokerUser}
          withTagFilter={isBrokerUser}
        />
        {isBrokerUser
          ? (
            <GeneralLayoutSearchFilterBroker
              withSimpleLocation
              filterKey={SearchTypes.MY_BOARD}
            />
          )
          : (
            <GeneralLayoutSearchFilter
              withStatusFilter
              withDelivery
              withSimpleLocation
              withTruckTypes={isCarrierUser}
              filterKey={SearchTypes.MY_BOARD}
              noRecentFilters
            />
          )}
        {!isCarrierUser && !isShipperUser && <GeneralLayoutRecentFilter filterKey={SearchTypes.MY_BOARD} />}
        <GeneralLayoutSidebar activePage="/" />
        <GeneralLayoutContent>
          {content}
        </GeneralLayoutContent>
      </GeneralLayoutOuterTop>
      <GeneralLayoutLoading />
    </GeneralLayout>
  )
}

export default React.memo(Home)
